import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';
import { getMomentLocale } from 'lang/util';
import { useViewlogies } from 'context';
import GuestForm from 'components/GuestForm';
import isEventStarted from 'components/GuestForm/isEventStarted';
import Subheader from './Subheader';
import VideoNavigation from './VideoNavigation';
import VideoPlayer from './VideoPlayer';
import './GuestSection/guestSection.scss';

const FuneralStream = () => {
    const {
        event: { isRsvpForm },
        streams,
        streamIndex,
        language,
        isMobile,
    } = useViewlogies();

    const wrapperRef = useRef(null);
    const [maxWidth, setMaxWidth] = useState('100%');

    const updateWidth = () => {
        if (!wrapperRef.current) return;

        // Check the max height we want
        const maxHeight = window.innerHeight;

        const aspectRatio =
            maxHeight < 620 ? 15 / 17 : maxHeight < 850 ? 13 / 17 : maxHeight < 1400 ? 12 / 17 : 11 / 17;

        // Calculate the max width that would not exceed the maxHeight
        const calculatedMaxWidth = maxHeight / aspectRatio;
        // Update the width
        setMaxWidth(`${Math.min(window.innerWidth, calculatedMaxWidth)}px`);
    };

    useEffect(() => {
        updateWidth();
        window.addEventListener('resize', updateWidth);

        return () => window.removeEventListener('resize', updateWidth);
    }, []);

    const eventStarted = isEventStarted(streams);

    return (
        <div className="funeral-stream-container">
            {!eventStarted && isRsvpForm && (
                <div className="guest-section">
                    <GuestForm isRsvpForm={true} />
                </div>
            )}
            <div className="video-tab-wrapper" ref={wrapperRef} style={!isMobile ? { maxWidth: maxWidth } : {}}>
                <Subheader />
                <VideoNavigation />
                <VideoPlayer />
            </div>
        </div>
    );
};

export default FuneralStream;
